<template>
  <form name="costumers" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show  m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>

    <div class="alert m-alert m-alert--default mb-3 mt-5" role="alert">
      <h5><i class="fas fa-phone"></i> Informações de contatos</h5>
    </div>
    <div v-for="contact in data" :key="contact.id">
      <div class="row mb-2">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6 mb-2">
              <input
                type="text"
                class="form-control form-control-sm mb-2"
                tabindex="1"
                placeholder="Nome"
                v-model="contact.name"
              />
              <input
                type="text"
                class="form-control form-control-sm mb-2"
                tabindex="3"
                placeholder="Telefone"
                v-model="contact.phone"
              />
              <select
                class="form-control form-control-sm"
                v-model="contact.type"
              >
                <option value="">Selecione o tipo</option>
                <option value="1">Outros</option>
                <option value="2">Responsável pela plataforma</option>
                <option value="3">Responsável financeiro</option>
              </select>
            </div>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control form-control-sm mb-2"
                tabindex="2"
                placeholder="Email"
                v-model="contact.email"
              />
              <input
                type="text"
                class="form-control form-control-sm"
                tabindex="4"
                placeholder="Cargo"
                v-model="contact.post"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-8">
              <div class="m-form__group form-group">
                <label for="">Recebe</label>
                <div class="m-checkbox-inline">
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="contact.report" /> Relatório
                    <span></span>
                  </label>
                  <label class="m-checkbox">
                    <input type="checkbox" v-model="contact.invoice" /> Fatura
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="m-form__group form-group">
                <button
                  type="button"
                  class="btn btn-sm btn-success m-btn m-btn--custom mt-2"
                  @click="saveForm(contact)"
                  v-b-tooltip.hover.left
                  title="Salvar"
                  :disabled="!contact.name || !contact.email || !contact.post"
                >
                  <i class="fas fa-save fa-lg"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger m-btn m-btn--custom mt-1"
                  @click="confirmDel(contact.id)"
                  v-b-tooltip.hover.left
                  title="Excluir"
                  :disabled="!contact.id"
                >
                  <i class="fal fa-trash-alt fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-4" />
    </div>
    <button
      type="button"
      class="btn btn-sm btn-success m-btn m-btn--custom"
      @click="data.push({ id: '', customer_id: customerId })"
    >
      <i class="fas fa-plus-circle"></i> Adicionar contato
    </button>
  </form>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';

export default {
  mixins: [returnMessageMixin],
  name: 'CustomerSaveForm',
  data() {
    return {
      data: [],
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    saveForm(contact) {
      const url = `${baseApiUrl}/v1/customer/contact/save`;
      axios
        .post(url, contact)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => this.logMessageFailed(error.response));
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir o contato selecionado?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> O contato não foi excluído!',
              {
                theme: 'toasted-primary',
                type: 'error',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/customer/contact/delete/${id}`;
      axios(url).then((res) => {
        if (res.status == 200) {
          this.$toasted.show(`<i class="fas fa-check-circle"></i> ${res.data.message}`, {
            theme: 'toasted-primary',
            type: 'success',
            position: 'top-right',
            duration: 5000,
          });
          this.getDatas();
        }
      });
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/contact/data/${this.customerId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
  },
  computed: {
    customerId() {
      return this.$store.state.showCustomerSave;
    },
  },
  watch: {
    customerId(newVal, oldVal) {
      if (newVal && newVal !== 'add' && newVal !== oldVal) {
        this.getDatas();
      }
    },
  },
  beforeMount() {
    if (this.customerId && this.customerId !== 'add') {
      this.callData();
    }
  },
};
</script>
